import { useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from 'react';
import { deleteMedia } from '../../store/reducers/media.reducer';

export const useDeleteMedia = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();

    const handleDeleteMedia = useCallback((mediaPoint) => {
        if (!keycloak.token || !mediaPoint) {
            console.error("Cannot delete: not authenticated or no media point provided.");
            return;
        }
        dispatch(deleteMedia({ mediaId: mediaPoint.id, token: keycloak.token }));
    }, [dispatch, keycloak.token]);

    return { handleDeleteMedia };
};